/**
 * Lightweight base class for all GameManagers.
 *
 * It holds shared references to the round context (rc) and
 * the game context (gc). Concrete managers still implement
 * the IGameManager interface themselves.
 */
export class Base_GameManager {
    constructor(rc, gc) {
        this.rc = rc;
        this.gc = gc;
    }
    getHeaderTitle() {
        return undefined;
    }
    getHeaderCssClasses() {
        return [];
    }
    getHeaderElementId() {
        return undefined;
    }
    getHeaderRender() {
        return undefined;
    }
}
//# sourceMappingURL=Base_GameManager.js.map